import axios from 'axios';
import getApiUrl from 'src/utils/get-api-url';

const apiUrl = getApiUrl();

/**
 * Get list of existing collaborators' position maps.
 * 
 * @returns {Promise<Object>}
 */
export function getPositionMaps() {
  return axios.get(`${apiUrl}/positionMaps`);
}
